import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { InteractiveText } from '@silvertours/front-shared';

const CollapseToggleWrapper = styled(InteractiveText)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[20]};
`;

const StyledButton = styled.button<{ isCollapsed: boolean }>`
  z-index: 20;
  ${({ theme, isCollapsed }) =>
    isCollapsed
      ? css`
          padding-top: ${theme.spacing[70]};
        `
      : css`
          margin-top: -3rem;
          position: absolute;
        `}
  background-color: #0000;
  border: none;
  cursor: pointer;
`;

export { CollapseToggleWrapper, StyledButton };
